import ImagePerson from "@/components/functionals/ImagePerson";
import ColorOfTasks from "@/components/internal_requests/KPI/TasksReport/ColorOfTasks";
import ColorsForProductivityAndNonProductivity from "@/components/functionals/ProductivityHour/ColorsForProductivityAndNonProductivity";
import LinkdialogOpener from "@/components/functionals/ProductivityHour/LinkdialogOpener";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter";

const columns = (thiss) => [
  {
    prop: "ResponsibleName",
    label: "Responsable",
    "min-width": 200,
    sortable: true,
    fixed: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: "ResponsiblePhoto"
    }
    //formatter: HyperlinkForModuleVacations
  },

  {
    prop: "TotalHours",
    label: "Horas",
    align: "center",
    "min-width": 100,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "TotalClosedHours",
    label: "Horas cerradas",
    align: "center",
    "min-width": 150,
    sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    // formatter: (row, column, rowValue) => (
    //    <LinkdialogOpener rowValue={rowValue} row={row} column={column} call={thiss.OpenDialodDetailList} />
    // )
  },
  {
    prop: "TotalInternalRequestsClosedHours",
    label: "Solicitudes Internas",
    align: "center",
    "min-width": 190,
    sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "TotalExternalRequestsClosedHours",
    label: "Solicitudes Externas",
    align: "center",
    "min-width": 190,
    sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "TotalOperacionalTasksClosedHours",
    label: "Tareas Operacionales",
    align: "center",
    "min-width": 190,
    sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "TotalEstrategicalTasksClosedHours",
    label: "Tareas Estratégicas",
    align: "center",
    "min-width": 170,
    sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "OverallProductivityPercentage",
    label: "Productividad",
    align: "center",
    "min-width": 150,
    sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(ColorsForProductivityAndNonProductivity, {
        props: {
          row,
          column,
          rowValue
        }
      });
    }
    // formatter: (row) => {
    //   return row.OverallProductivityPercentage.toFixed(2) + " %";
    // }
  },

  {
    prop: "RemainingHours",
    label: "Horas no productivas",
    align: "center",
    "min-width": 190,
    sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(ColorsForProductivityAndNonProductivity, {
        props: {
          row,
          column,
          rowValue
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  }
];

const TasksAndRequestColumns = [
  {
    prop: "ID",
    label: "No. ",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: ColorOfTasks
  },
  {
    prop: "Name",
    label: "Descripción",
    "min-width": 130,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "ResponsibleName",
    label: "Responsable",
    "min-width": 130,
    sortable: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: "ResponsiblePhoto"
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "TimeOntask",
    label: "Tiempo en Horas",
    "min-width": 150,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "DelayedDays",
    label: "Rettraso",
    "min-width": 100,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "CloseDate",
    label: "Fecha de cierre",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: DatetimeFormatter
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "DueDate",
    label: "Fecha de compromiso",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: DatetimeFormatter
    //formatter: HyperlinkForModuleVacations
  }
];

export { columns, TasksAndRequestColumns };
